<template lang="pug">
nav.nav-bar.nav-bar-admin.container-fluid
  .d-flex.align-items-center
    .col-auto
      a.brand(@click="goToHome()")
        img(src='../assets/logo-adherencia.png', alt='Adherencia' class='img-fluid pt-2')
    .col-auto.mr-5.ml-auto.navbar__item.align-self-end
      c-dropdown.account(placement='bottom-end')
        .navbar__item.ml-auto
          a.account(role='button')
            .account__content.text-right.mr-2
              .account__title.text-capitalize
                | {{userinfo.name}} &nbsp;
                br
                small.account__meta.text-capitalize
                  | {{userinfo.profile.name}} &nbsp;
            figure.account__media
              img.avatar(src='../assets/avatar.jpg', alt='')
            .account__after
              font-awesome-icon(icon="angle-down")
        c-dropmenu(slot='content')
          //.- c-dropmenu-item(title="Manual de usuario", href="https://xd.adobe.com/view/88f37891-5e3a-455a-67d9-b382fc7c9142-fec2/?fullscreen", target="_blank")
          //.- c-dropmenu-divider
          c-dropmenu-item(icon='fas fa-unlock-alt', title='Cambiar clave', v-on:click='changePwd()')
          c-dropmenu-item(icon='fas fa-power-off', title='Salir', v-on:click='logOut()')
          c-dropmenu-divider
          .u-text-center
            p.u-text-muted.u-center-block v{{version}}
  
  .d-flex.mt-2.align-items-end
    .col
      ul.nav-menu.nav-menu-admin
        li(v-show="userinfo.isAdminOfUsers")
          router-link(to="/administracion/id") Inicio
        li(v-show="userinfo.isAdminOfUsers")
          router-link(to="/administracion/id/usuarios") Usuarios
        li(v-show="userinfo.isAdminOfUsers")
          router-link(to="/reportes") Reportes
        li(v-show="userinfo.isAdminOfUsers")
          router-link(to="/excepcion-cierre-planificacion") Excepcion cierre de planificacion
        
        li.ml-auto.px-5
          a(@click="goToHome()")
            i.icon-xs.icon-arrow-left.mr-2
            | Volver al sistema
        
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import jsonpck from '../../package.json'
import moment from 'moment'

export default {
  name: 'AdminNavbar',
  data () {
    return {
      userinfo: {
        name: null,
        profile: {
          name: null
        }
      },
      pisopen: null,
      version: null,
      permissions: {
        home: true,
        planificacion_semanal: true,
        dialogo_desempeno: true,
        confirmacion_procesos: true,
        dialogo_desempeno: true,
        seguimiento_diario: true
      },
    }
  },
  methods: {
    moment,
    ...mapActions('plan', [
      'planIsOPenByWeek'
    ]),
    goTo (namepath) {
      this.$router.replace({path: namepath})
    },  
    toggleSider () {
      this.$root.siderOpen = !this.$root.siderOpen
    },
    goToHome() {
      const vm = this        
      if (vm.userinfo.profile.name.toLowerCase().trim() == 'consultor') {        
        vm.$router.replace({path: '/consultor'})
      } else {
        vm.$router.replace({path: '/home'})
      }
    },
    logOut () {
      const vm = this      
      this.$store.dispatch('auth/logOut').then(() => {        
        vm.$router.replace({path: '/'})        
      })     
    },
    changePwd () {
      this.$router.replace('/change-password')
    },
    validateIsAdmin() {
      const vm = this
      if (!vm.userinfo.isAdminOfUsers) {
        vm.goToHome()
      }
    },
    _canSee (tab) {
      const vm = this
      for (let p in vm.permissions) {
        vm.permissions[p] = vm.$store.getters['auth/canAccessTab'](p)
      }
    },
    planIsOpen () {
      const vm = this
      vm.planIsOPenByWeek({date: Date.now(), id: vm.userinfo.id}).then(() => {
        vm.pisopen = vm.pisopen === 'hide' ? false : vm.$store.getters['plan/getPlanIsOpen']
      }, (error) => {
        vm.$notify({
          type: 'danger',
          title: 'Notificación',
          content: error.payload.message,
          closeable: true,
          duration: 5000
        })
      })
    }
  },
  computed: {
    ...mapGetters('plan', {
      plan: 'getPlan'      
    })
  },
  mounted () {
    this.$root.$on('hidePlanification', text => {
      this.pisopen = text
    })
    this.userinfo = this.$store.getters['auth/getUserInfo']
    this.version = jsonpck.version
    this.validateIsAdmin()
    this._canSee()
    this.planIsOpen()  
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin-navbar.vue